import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css'
import "bootstrap"
import router from './router'

import VueApexCharts from "vue3-apexcharts";

createApp(App).use(VueApexCharts).use(router).mount('#app')
